/* apps/viewer/src/app/pdf/pdf.component.scss */
:host {
  display: block;
  height: calc(100vh - 60px);
}
:host ng2-pdfjs-viewer {
  display: block;
  height: 100%;
  width: 100%;
}
:host ng2-pdfjs-viewer.print_view {
  height: 100vh;
}
:host ng2-pdfjs-viewer ::ng-deep iframe {
  display: block;
}
:host .notes-button {
  position: absolute;
  right: 10px;
  top: 100px;
}
/*# sourceMappingURL=pdf.component.css.map */
